import "../styles/servicestyle.css";

export default function Services() {
  const steps = [
    {
      n: 1,
      t: "Discovery",
      d: "We dive deep into your goals, audience, and business model to understand exactly what you need.",
    },
    {
      n: 2,
      t: "Strategy",
      d: "Creating a detailed roadmap and choosing the right tech stack tailored to your project.",
    },
    {
      n: 3,
      t: "Design",
      d: "Crafting beautiful, user-tested prototypes and intuitive interfaces that convert.",
    },
    {
      n: 4,
      t: "Development",
      d: "Writing clean, scalable, and maintainable code to bring the design to life.",
    },
    {
      n: 5,
      t: "Launch",
      d: "Rigorous testing, deployment, and ongoing support to keep your product running perfectly.",
    },
  ];

  return (
    <>
      <section className="services-hero">
        <div className="hero-content">
          <span className="badge">What We Offer</span>
          <h1>
            Our Professional <span>Services</span>
          </h1>
          <p>
            We don't just teach — we build. From web solutions to digital
            branding, we help your business scale with real tech.
          </p>
        </div>
      </section>

      <section className="services-grid-section">
        <div className="section-title">
          <span className="section-label">Solutions</span>
          <h2>
            What We <span>Offer</span>
          </h2>
          <p>
            End-to-end tech services delivered by experts who actually know what
            they're doing.
          </p>
        </div>
        <div className="modern-grid">
          <div className="modern-card">
            <div className="card-img-container">
              <img
                src="https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=400"
                alt="Web Dev"
              />
            </div>
            <div className="card-info">
              <h3>Web Development</h3>
              <p>
                Custom, high-performance websites built with the MERN stack —
                fast, scalable, and beautiful.
              </p>
              <button className="hire-btn">Hire Now →</button>
            </div>
          </div>
          <div className="modern-card">
            <div className="card-img-container">
              <img
                src="https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400"
                alt="Design"
              />
            </div>
            <div className="card-info">
              <h3>UI/UX Design</h3>
              <p>
                Modern, user-centric designs that don't just look good — they
                convert visitors into customers.
              </p>
              <button className="hire-btn">Hire Now →</button>
            </div>
          </div>
          <div className="modern-card">
            <div className="card-img-container">
              <img
                src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400"
                alt="App Dev"
              />
            </div>
            <div className="card-info">
              <h3>App Development</h3>
              <p>
                Smooth, cross-platform Android and iOS apps built with React
                Native for maximum reach.
              </p>
              <button className="hire-btn">Hire Now →</button>
            </div>
          </div>
        </div>
      </section>

      <section className="process-section">
        <div className="section-title">
          <span className="section-label">Workflow</span>
          <h2>
            How We Bring <span>Results</span>
          </h2>
          <p>
            A proven 5-step process that takes your idea from concept to live
            product.
          </p>
        </div>
        <div className="timeline">
          {steps.map((step) => (
            <div className="timeline-item" key={step.n}>
              <div className="step-num">{step.n}</div>
              <div className="timeline-content">
                <h3>{step.t}</h3>
                <p>{step.d}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-banner">
        <h2>Have a project in mind?</h2>
        <p>Let's collaborate and build something extraordinary together.</p>
        <button className="join-btn">Get a Free Quote →</button>
      </section>
    </>
  );
}
